import { render, staticRenderFns } from "./JackpotContent.vue?vue&type=template&id=864ecf0a&scoped=true"
import script from "./JackpotContent.vue?vue&type=script&lang=js"
export * from "./JackpotContent.vue?vue&type=script&lang=js"
import style0 from "./JackpotContent.vue?vue&type=style&index=0&id=864ecf0a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "864ecf0a",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CommonsNuxtImage: require('/app/components/Commons/NuxtImage.vue').default,Theme2DesktopJackpotInterval: require('/app/components/Theme2/Desktop/JackpotInterval.vue').default})
